import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1166bdda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "row my-3" }
const _hoisted_4 = { class: "col-12 col-lg-4 mb-1" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "",
  fill: "#000",
  height: "40",
  width: "40"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-training" })
], -1))
const _hoisted_7 = { class: "text-primary mb-0 mb-lg-2" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "col-12 col-lg-4 mb-1" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "",
  fill: "#000",
  height: "40",
  width: "40"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-ticket-warning" })
], -1))
const _hoisted_12 = { class: "text-primary mb-0 mb-lg-2" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "col-12 col-lg-4 mb-1" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "",
  fill: "#000",
  height: "40",
  width: "40"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-support-avatar" })
], -1))
const _hoisted_17 = { class: "text-primary mb-0 mb-lg-2" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "lead" }
const _hoisted_23 = { class: "d-flex mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Column = _resolveComponent("Column")!
  const _component_StatusBadge = _resolveComponent("StatusBadge")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.vm.pageTitle), 1),
      (_ctx.vm.askAQuestionPageUrl)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "p-button-raised p-button-success p-button-arrow",
            label: _ctx.$t('myCadac.supportTicketOverview.button.askAQuestion'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
				_ctx.openUrl(_ctx.vm.askAQuestionPageUrl);
				$event.target.disabled = true;
			})
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Card, {
          id: "card-supportTickets-1",
          class: "support-ticket-card"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Avatar, {
                class: "mr-1 bg-transparent",
                shape: "square",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.vm?.openTicketCount), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("myCadac.supportTicketOverview.card.questions")), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Card, {
          id: "card-supportTickets-2",
          class: "support-ticket-card"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Avatar, {
                class: "mr-1 bg-transparent",
                shape: "square",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.vm?.actionRequiredTicketCount), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$tc(
										"myCadac.supportTicketOverview.card.actions",
										_ctx.vm?.actionRequiredTicketCount
									)), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Card, {
          id: "card-supportTickets-3",
          class: "support-ticket-card"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Avatar, {
                class: "mr-1 bg-transparent",
                shape: "square",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.vm?.inProgressTicketCount), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("myCadac.supportTicketOverview.card.inProgress")), 1)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        (_ctx.tableData.length)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 0,
              breakpoint: "991px",
              class: "mt-2",
              "removable-sort": "",
              "responsive-layout": "stack",
              value: _ctx.tableData
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  key: "id",
                  field: "id",
                  header: _ctx.$t('myCadac.supportTicketOverview.table.colId'),
                  sortable: false
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  key: "subject",
                  field: "subject",
                  header: _ctx.$t('myCadac.supportTicketOverview.table.colSubject'),
                  sortable: false
                }, {
                  body: _withCtx((item) => [
                    _createElementVNode("a", {
                      class: "text-blue",
                      href: item.data.ticketUrl,
                      rel: "noreferrer noopener",
                      target: "_blank"
                    }, [
                      _createElementVNode("b", null, _toDisplayString(item.data.subject), 1)
                    ], 8, _hoisted_21)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  key: "mainCategory",
                  field: "mainCategory",
                  header: _ctx.$t('myCadac.supportTicketOverview.table.colType'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  key: "modified",
                  field: "modified",
                  header: _ctx.$t('myCadac.supportTicketOverview.table.colModified'),
                  sortable: true
                }, {
                  body: _withCtx((item) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(item.data.modified)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  key: "status",
                  field: "status",
                  header: _ctx.$t('myCadac.supportTicketOverview.table.colStatus'),
                  sortable: true
                }, {
                  body: _withCtx((item) => [
                    _createVNode(_component_StatusBadge, {
                      status: item.data.simpleStatus,
                      "translation-prefix": 'myCadac.supportTicketOverview.badge_status'
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        (!_ctx.tableData.length)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              class: "mx-auto mt-2"
            }, {
              content: _withCtx(() => [
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("myCadac.supportTicketOverview.card.noTicketsWarning")), 1),
                _createVNode(_component_Button, {
                  class: "p-button-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUrl(_ctx.vm.askAQuestionPageUrl)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.supportTicketOverview.card.noTicketsCta")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          (_ctx.tableData.length && _ctx.vm.showAllTicketsCtaLinkItemHref)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-primary p-button-raised",
                label: _ctx.vm.showAllTicketsCtaLinkItemText,
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
						_ctx.openUrl(_ctx.vm.showAllTicketsCtaLinkItemHref, _ctx.vm.showAllTicketsCtaLinkItemTarget);
						$event.target.disabled = true;
					})
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}